import React from "react";
import { Box, Paper, Rating, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const RatingSize = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Sizes
        </Typography>
        <Typography variant={"body1"} color={"text.primary"}>
          For larger or smaller ratings use the size prop.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <PreviewAndEditor language={"js"} value={
          `
          <Rating name="size-small" defaultValue={2} size="small" />
          <Rating name="size-medium" defaultValue={2} />
          <Rating name="size-large" defaultValue={2} size="large" />
          `
        }>
          <Stack spacing={1}>
            <Rating name="size-small" defaultValue={2} size="small" />
            <Rating name="size-medium" defaultValue={2} />
            <Rating name="size-large" defaultValue={2} size="large" />
          </Stack>
        </PreviewAndEditor>
      </Paper>
    </Stack>
  );
};

export default RatingSize;
